<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewUserGoogle-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewUserGoogle-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><path d="M120 256c0-25.367 6.99-49.13 19.13-69.477v-86.308H52.823C18.568 144.703 0 198.922 0 256s18.568 111.297 52.823 155.785h86.308v-86.308C126.99 305.13 120 281.367 120 256z" fill="#fbbd00"/><path d="M256 392l-60 60 60 60c57.08 0 111.297-18.568 155.785-52.823V372.96H325.57C305.044 385.147 281.18 392 256 392z" fill="#0f9d58"/><path d="M139.13 325.477l-86.308 86.308C59.605 420.593 67 429.028 74.98 437.02 123.333 485.37 187.62 512 256 512V392c-49.624 0-93.117-26.72-116.87-66.523z" fill="#31aa52"/><path d="M512 256a258.24 258.24 0 0 0-4.192-46.377l-2.25-12.3H256v120h121.452c-11.794 23.46-29.928 42.602-51.884 55.638l86.216 86.216c8.808-6.782 17.243-14.167 25.235-22.158C485.37 388.667 512 324.38 512 256z" fill="#3c79e6"/><path d="M352.167 159.833l10.606 10.606 84.853-84.852L437.02 74.98C388.668 26.63 324.38 0 256 0l-60 60 60 60c36.326 0 70.48 14.146 96.167 39.833z" fill="#cf2d48"/><path d="M256 120V0C187.62 0 123.333 26.63 74.98 74.98a259.85 259.85 0 0 0-22.158 25.235l86.308 86.308C162.883 146.72 206.376 120 256 120z" fill="#eb4132"/></svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNewUser_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNewUserGoogle_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddNewUserGoogle-wrapper-inputs lxn-margin-auto lxn-border-round">
      <div class="AddNewUserGoogle-input-spacer">
      </div>
      <customInput v-model="mobile" @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" :placeHolder="$store.getters.language.texts.AddNewUserGoogle_placeHolder" inputType="text">
      </customInput>
      <div class="AddNewUserGoogle-input-spacer">
      </div>
      <customInput v-model="name" @focus="input2State='active'" @blur="input2State=''" :inputState="input2State" :placeHolder="$store.getters.language.texts.AddNewUser_placeHolder2" inputType="text">
      </customInput>
    </div>
    <div class="AddNewUserGoogle-button lxn-margin-auto lxn-w100">
      <CustomButton @click="addNewUser" bgColor="#1EA5DE" iconRight="verySecure" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNewUser_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomInput from '@/components/CustomInput.vue'
import md5 from 'md5'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'AddNewUserGoogle',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton,
    CustomInput
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
      mobile: '',
      name: '',
      input1State: '',
      input2State: ''
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    addNewUser: function () {
      this.input1State = '';
      this.input2State = '';
      if(this.mobile == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddNewUserGoogle_alert1);
      }else if(this.name == ''){
        this.input2State = 'error';
        alert(this.$store.getters.language.texts.AddNewUser_alert2);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.dispatch('saveDatabase', this.hub.uuid)
        .then( () => {
          this.$store.dispatch('getUserUuidFromGmail', this.mobile).then(response => {
            if(response.data.status == 'success'){
              var userUUID = response.data.user_uuid;
              if(this.$store.getters.getUserByUUID(this.hub.index, userUUID) != -1){
                alert(this.$store.getters.language.texts.AddNewUser_alert3);
                this.input1State = 'error';
                this.$store.commit('setAppBusy', false);
              }else{
                var uuids = [];
                for(var i = 0; i < this.hub.users.length; i++){
                  if(!this.hub.users[i].isOwner){
                    uuids.push(this.hub.users[i].uuid);
                  }
                }
                uuids.push(userUUID);
                this.$store.dispatch('grantSnapshotAccess', {
                  userUUID: this.$store.state.user.uuid,
                  token: this.$store.state.user.loginToken,
                  hubUUID: this.hub.uuid,
                  uuids: uuids,
                })
                .then(response => {
                  if(response.data.status == 'success'){
                    var messagingHook = new Messaging(new Logger(false));
                    var generatedPassword = Math.floor(Math.random()*90000) + 10000;
                    generatedPassword = generatedPassword.toString();
                    messagingHook.init({
                      psk: this.hub.psk,
                      destinationUUID: this.hub.uuid,
                      sourceUUID: this.$store.state.user.uuid
                    });
                    this.$store.dispatch('addUserToHub', {
                      messagingHook: messagingHook,
                      hubUUID: this.hub.uuid,
                      bodyContent: {
                        newUserUUID: userUUID,
                        password: md5(generatedPassword),
                      }
                    })
                    .then( () => {
                      this.$store.commit('addNewUserToHub', {hubIndex: this.hub.index, uuid: userUUID,name: this.name, isOwner: false,mobile: this.mobile});
                      this.$store.commit('saveState');
                      this.$store.dispatch('saveDatabase', this.hub.uuid)
                      .finally( () => {
                        this.$router.push('/newUserCredentials/' + this.hub.uuid + '/' + generatedPassword);
                        this.$store.commit('setAppBusy', false);
                      })
                    })
                    .catch( response => {
                      if(response.rejectCode == 2){
                        this.$store.commit('setHubStatus', {
                          hubIndex: response.hubIndex,
                          connectionStatus: {
                            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                          },
                        });
                      }
                      this.$router.push('/SettingsHubError');
                      this.$store.commit('setAppBusy', false);
                    });
                  }else{
                    alert(this.$store.getters.language.texts.AddNewUserGoogle_serverResponseFail);
                    this.$store.commit('setAppBusy', false);
                  }
                })
                .catch(() => {
                  alert(this.$store.getters.language.texts.Common_internetError);
                  this.$store.commit('setAppBusy', false);
                });
              }
            }else{
              alert(this.$store.getters.language.texts.AddNewUserGoogle_serverResponseFail);
              this.$store.commit('setAppBusy', false);
            }
          })
          .catch(() => {
            alert(this.$store.getters.language.texts.Common_internetError);
            this.$store.commit('setAppBusy', false);
          })
        })
        .catch( response => {
          if(response.errorCode == 1){
            alert(this.$store.getters.language.texts.AddNewUserGoogle_serverResponseFail);
            this.$store.commit('setAppBusy', false);
          }else if(response.errorCode == 2){
            alert(this.$store.getters.language.texts.Common_internetError);
            this.$store.commit('setAppBusy', false);
          }
        });
      }
    }
  }
}
</script>

<style>
  .AddNewUserGoogle-topCurve-wrapper {
    height: 200px;
  }
  .AddNewUserGoogle-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNewUserGoogle-wrapper-inputs {
    width: calc(100% - 36px);
    height: 148px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .AddNewUserGoogle-input-spacer {
    height: 16px;
  }
  .AddNewUserGoogle-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddNewUserGoogle-st0 {
    fill: #ECECEC;
  }
	.AddNewUserGoogle-st1 {
    fill: #53636C;
  }
	.AddNewUserGoogle-st2 {
    fill: #1EA5DE;
  }
</style>
